<template>
  <div class="">
    <div class="tw-bg-black tw-py-4 tw-px-8 tw-text-white tw-flex tw-cursor-pointer lg:tw-cursor-default" @click="toggleDetailsOpen">
      <h3 class="tw-text-2xl tw-font-black tw-uppercase">Your Order Details</h3> <span :class="['tw-ml-auto fa fa-chevron-right tw-transition lg:tw-hidden', {'tw-rotate-90': detailsOpen}]"></span>
    </div>
    <TwCollapse
      :duration="300"
      :collapseOpen="detailsOpen">
      
      <div class="tw-py-8 tw-px-8 tw-flex">
        <dl class="tw-text-xl tw-w-full tw-grow">
          <div class="sm:tw-px-0 tw-mb-4 tw-flex" v-if="cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder!.delivery_mode">
            <dt class="tw-inline-block tw-w-1/3 tw-font-bold">
              Order Type:
            </dt>
            <dd class="tw-inline-block w-w-2/3 tw-uppercase">
              {{cateringOrderStore.cateringOrder!.delivery_mode}}
            </dd>
          </div>

          <div class="sm:tw-px-0 tw-mb-4 tw-flex">
            <dt class="tw-inline-block tw-w-1/3 tw-font-bold">
              Store:
            </dt>
            <dd class="tw-inline-block w-w-2/3" v-if="userStore.userLocation">
              {{userStore.userLocation.name}}<br>
              {{userStore.userLocation.streetaddress}}<br>
              {{userStore.userLocation.city}}, {{userStore.userLocation.state}} {{userStore.userLocation.zip}}
            </dd>
          </div>
        </dl>

        <div class="tw-text-lg">
          <router-link :to="{ name: 'wizard-step', params: { step:  1}}">edit</router-link>
        </div>
      </div>

      <div class="tw-py-8 tw-px-8 tw-border-t tw-border-b tw-border-black">
        <div class="tw-text-xl tw-mb-8 tw-text-orange-medium tw-font-bold tw-flex tw-items-center" v-if="makeTimeExceedsTimeWanted">
          <div class="tw-mr-6">
            <span class="fa fa-exclamation-circle tw-text-5xl"></span>
          </div>
          <div class="tw-mr-4">Your order cannot be completed by the time you currently have selected. Click "edit" to select an available time.</div>
        </div>

        <div class="tw-flex">
          <dl class="tw-text-xl tw-w-full tw-grow">
            <div class="sm:tw-px-0 tw-mb-4 tw-flex">
              <dt class="tw-inline-block tw-w-1/3 tw-font-bold">
                Date:
              </dt>
              <dd class="tw-inline-block tw-w-2/3" v-if="timeWanted">
                {{timeWanted.toFormat('MMMM dd')}}
              </dd>
            </div>

            <div class="sm:tw-px-0 tw-mb-4 tw-flex">
              <dt class="tw-inline-block tw-w-1/3 tw-font-bold">
                Time:
              </dt>
              <dd class="tw-inline-block w-w-2/3" v-if="timeWanted">
                {{timeWanted.toFormat('h:mm a')}}
              </dd>
            </div>
          </dl>

          <div class="tw-text-lg">
            <router-link :to="{ name: 'wizard-step', params: { step: 4}}">edit</router-link>
          </div>
        </div>
      </div>
    </TwCollapse>

    <div class="tw-py-8 tw-px-8" v-if="cateringOrderStore.cateringOrder ">
      <template v-if="false">(cateringOrderStore.cateringOrder.light_eaters | cateringOrderStore.cateringOrder.regular_eaters | cateringOrderStore.cateringOrder.hungry_eaters)</template>
      <FeederMeter
        :cateringOrder="cateringOrderStore.cateringOrder"
        :guestsFed="baselineCovered" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed, ref, nextTick } from 'vue'
import { DateTime } from "luxon";

// Data
import { useBasketStore } from "../../stores/basket";
import { useCateringOrderStore } from "../../stores/catering_order";
import { useUserStore } from '../../stores/user';

import FeederMeter from './_FeederMeter.vue';
import TwCollapse from '../../components/TwCollapse.vue';

const basketStore = useBasketStore();
const cateringOrderStore = useCateringOrderStore();
const userStore = useUserStore();

const detailsOpen = ref(true);

onMounted(() => {
  let vm = this;
  nextTick(() => {
    window.addEventListener('resize', onResize);
  })
})

const onResize = (() => {
  if (window.innerWidth > 1023) {
    // auto show the collapsed order details since user can't toggle it
    detailsOpen.value = true;
  }
})

const baselineCovered = computed(() => {
  if (cateringOrderStore.cateringOrder!.guest_count && basketStore.basket) {
    let guestHungerArray = [cateringOrderStore.cateringOrder!.light_eaters, cateringOrderStore.cateringOrder!.regular_eaters, cateringOrderStore.cateringOrder!.hungry_eaters];
    return basketStore.basket.basketFeeds(guestHungerArray, cateringOrderStore.cateringOrder!.guest_count, undefined)
  } else {
    return 0;
  }
})

const timeWanted = computed(() => {
  if (cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder!.time_wanted) {
    let dt = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted);
    return dt;
  } else {
    return null
  }

})

const toggleDetailsOpen = (() => {
  if (window.innerWidth < 1024) {
    detailsOpen.value = !detailsOpen.value
  }
})

const makeTimeExceedsTimeWanted = computed(() => {
  let bool = false;
  if (basketStore.basket && timeWanted.value && userStore.userLocation && cateringOrderStore.cateringOrder) {
    bool = !basketStore.basket!.canBeMadeByTime(timeWanted.value, userStore.userLocation, cateringOrderStore.cateringOrder!.delivery_mode)
  }

  return bool;
})

</script>